import { render, staticRenderFns } from "./LoopIcon.vue?vue&type=template&id=3b4c4e54&scoped=true&"
import script from "./LoopIcon.vue?vue&type=script&lang=js&"
export * from "./LoopIcon.vue?vue&type=script&lang=js&"
import style0 from "./LoopIcon.vue?vue&type=style&index=0&id=3b4c4e54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c4e54",
  null
  
)

export default component.exports